{
  "version": 1,
  "asset_id": "c6bf8544-3eb4-4ab1-a089-63c7f4fe4147",
  "project_id": "8f4e0cb3-546d-4528-9687-8899f14664d6",
  "url": "/__l5e/assets-v1/c6bf8544-3eb4-4ab1-a089-63c7f4fe4147/ia-itv-maquinas-hielo.png",
  "r2_key": "a/v1/8f4e0cb3-546d-4528-9687-8899f14664d6/c6bf8544-3eb4-4ab1-a089-63c7f4fe4147/ia-itv-maquinas-hielo.png",
  "original_filename": "ia-itv-maquinas-hielo.png",
  "size": 247588,
  "content_type": "image/png",
  "created_at": "2026-11-05T15:14:36Z"
}
